import {commitMutation, graphql} from 'react-relay';
import environment from '../data/environment';

const mutation = graphql`
  mutation ArchiveReportMutation(
    $input: ArchiveReportInput!
  ) {
    archiveReport(input: $input) {
      report {
        id
      }
    }
  }
`;

function commit({reportId}, callback) {
  commitMutation(
    environment,
    {
      mutation,
      variables: {
        input: {
          reportId,
        },
      },
      onCompleted: (res) => {
        callback(null, res.archiveReport.report.id);
      },
      onError: (err) => {
        callback(err);
      },
    },
  );
}

export default {commit};



// WEBPACK FOOTER //
// ./src/mutations/ArchiveReportMutation.js